import React from 'react'
import { CreditApplication, CreditApplicationStatus } from '_gql'

import InReviewSubmittedStatusTile from '@sputnik/pages/Dashboard/Status/InReviewSubmittedStatusTile'

import FrozenCreditStatusTile from './FrozenCreditStatusTile'
import { useGetFrozenStatus } from './GetFrozenStatus.gql'
import MoreInfoNeededStatusDocumentsTile from './MoreInfoNeededStatusDocumentsTile'
import MoreInfoNeededStatusPersonaTile from './MoreInfoNeededStatusPersonaTile'

export interface MoreInfoNeededProps {
  creditApp: CreditApplication
  refetch: () => void
}

const MoreInfoNeeded = ({ creditApp, refetch }: MoreInfoNeededProps) => {
  const { status, requiredDocs, personaInquiries } = creditApp

  const personaInquiriesToComplete = personaInquiries?.filter((inquiry) => !inquiry.status?.includes('COMPLETED')) || []

  const hasRequiredDocuments = requiredDocs && requiredDocs.length > 0
  const hasPersonaInquiries = personaInquiriesToComplete?.length > 0

  const { data } = useGetFrozenStatus({
    variables: { companyId: creditApp?.companyDivvyUuid ?? '' },
  })

  const { frozenAuthorizedSigner } = data ?? {}

  if (frozenAuthorizedSigner) {
    return <FrozenCreditStatusTile creditApp={creditApp} />
  }

  if (status === CreditApplicationStatus.MORE_INFO_NEEDED && (hasRequiredDocuments || hasPersonaInquiries)) {
    return (
      <>
        {hasRequiredDocuments && (
          <MoreInfoNeededStatusDocumentsTile
            creditApp={creditApp}
            refetch={refetch}
          />
        )}
        {hasPersonaInquiries && (
          <MoreInfoNeededStatusPersonaTile
            creditApp={creditApp}
            personaInquiriesToComplete={personaInquiriesToComplete}
            refetch={refetch}
          />
        )}
      </>
    )
  }

  // the status stays more_info_needed, but we need to show that it's in review after they upload all the documents they requested
  return (
    <InReviewSubmittedStatusTile
      moreInfoInReview
      creditApp={creditApp}
    />
  )
}

export default MoreInfoNeeded
